import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import GradientBackground from "@/components/GradientBackground";
import ParticleBackground from "@/components/ParticleBackground";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen relative overflow-hidden">
      <GradientBackground />
      <ParticleBackground />
      
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 text-center">
        <div className="glass rounded-2xl p-8 md:p-12 max-w-md w-full border border-border/50 animate-fade-in">
          {/* 404 Number */}
          <div className="relative mb-6">
            <h1 className="text-8xl md:text-9xl font-black gradient-text opacity-20">
              404
            </h1>
            <div className="absolute inset-0 flex items-center justify-center">
              <Search className="h-16 w-16 text-primary animate-pulse" />
            </div>
          </div>

          {/* Message */}
          <h2 className="text-2xl md:text-3xl font-bold mb-3">Page Not Found</h2>
          <p className="text-muted-foreground mb-8">
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              variant="outline"
              onClick={() => window.history.back()}
              className="gap-2"
            >
              <ArrowLeft className="h-4 w-4" />
              Go Back
            </Button>
            <Link to="/">
              <Button className="gap-2 w-full sm:w-auto">
                <Home className="h-4 w-4" />
                Return Home
              </Button>
            </Link>
          </div>

          {/* Footer */}
          <p className="mt-8 text-sm text-muted-foreground">
            Powered by <span className="text-primary font-semibold">TAM</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
